import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import type { Geometry, Point } from '../search-context-utils';
export interface SearchMapContextValue {
  setMapGeoSearchBox: (geoBox: Geometry) => void;
  geoSearchBox: Geometry | undefined;
  centerPoint: Point | undefined;
  mapZoom?: number;
  mapViewportManuallyChanged: boolean;
  markMapViewportAsManuallyChanged: VoidFunction;
}
const SearchMapContext = React.createContext<SearchMapContextValue | undefined>(undefined);
interface SearchMapProviderProps {
  value: SearchMapContextValue;
  children: React.ReactNode;
}
export const SearchMapProvider: React.FC<SearchMapProviderProps> = t0 => {
  const $ = _c(3);
  const {
    value,
    children
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== value) {
    t1 = <SearchMapContext.Provider value={value}>{children}</SearchMapContext.Provider>;
    $[0] = children;
    $[1] = value;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export const useSearchMap = () => {
  const context = React.useContext(SearchMapContext);
  if (context === undefined) {
    throw new Error("useSearchMap must be used within a SearchProvider");
  }
  return context;
};